<p
  class="document-working-copy-toast__message"
  [innerHTML]="'unsavedWorkingCopyToast' | translate: { documentName: escapedDocumentName }"
></p>
<div class="document-working-copy-toast__actions">
  <button type="button" class="document-working-copy-toast__open" (click)="openDocument()">
    {{ 'openDocument' | translate }}
  </button>
  <button
    type="button"
    class="document-working-copy-toast__close"
    [attr.aria-label]="'close' | translate"
    (click)="dismiss()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
